import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import Landing from './pages/Landing';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';
import ClientDashboard from './pages/ClientDashboard';
import AdminDashboard from './pages/AdminDashboard';
import PMDashboard from './pages/PMDashboard';
import VendorDashboard from './pages/VendorDashboard';
import CreativeDashboard from './pages/CreativeDashboard';
import AdminInquiriesPage from './pages/AdminInquiriesPage';
import LegalPage from './pages/LegalPage';
import { PaymentSuccess } from './components/Billing';
import Login from './pages/Login';
import Register from './pages/Register';
import { AuthProvider, useAuth } from './context/AuthContext';
import '@/App.css';

function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#D4AF37]"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/" />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services" element={<Services />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/legal/:type" element={<LegalPage />} />
            <Route
              path="/dashboard/client/*"
              element={
                <ProtectedRoute requiredRole="client">
                  <ClientDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/admin/*"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/inquiries"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminInquiriesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/pm/*"
              element={
                <ProtectedRoute requiredRole="project_manager">
                  <PMDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/vendor/*"
              element={
                <ProtectedRoute requiredRole="vendor">
                  <VendorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/creative/*"
              element={
                <ProtectedRoute requiredRole="creative_team">
                  <CreativeDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<Navigate to="/dashboard/client" />} />
            <Route path="/subscription/success" element={<PaymentSuccess />} />
            <Route path="/subscription/cancel" element={<Navigate to="/dashboard/client" />} />
          </Routes>
          <Toaster position="top-right" theme="dark" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;